<div class="container" *ngIf="pageMode$ | async as pageMode">

    <!-- <div class="alert alert-warning row">
        <div class="col-6 col-lg-3">isMobile$: {{isMobile$ | async}}</div>
        <div class="col-6 col-lg-3">pageMode$: {{pageMode$ | async}}</div>
        <div class="col-6 col-lg-3">isLoading$: {{isLoading$ | async}}</div>
        <div class="col-6 col-lg-3">isSending$: {{isSending$ | async}}</div>
        <div class="col-6 col-lg-3">searchIsExpanded$: {{searchIsExpanded$ | async}}</div>
        <div class="col-6 col-lg-3">searchText$: {{searchText}}</div>
        <div class="col-6 col-lg-3">isFilterByUnread$: {{isFilterByUnread$ | async}}</div>
        <div class="col-6 col-lg-3">isSortDescending$: {{isSortDescending$ | async}}</div>
        <div class="col-6 col-lg-3" *ngIf="emailSearchSummary$ | async as searchSummary">emailSearchSummary$.count: {{searchSummary.count}}</div>
        <div class="col-6 col-lg-3" *ngIf="clientSearchSummary$ | async as searchSummary">clientSearchSummary$.count: {{searchSummary.count}}</div>
        <div class="col-6 col-lg-3">selectedEmailFromList$: {{!!(selectedEmailFromList$ | async)}}</div>
        <div class="col-6 col-lg-3">isFullScreenEmailView$: {{isFullScreenEmailView$ | async}}</div>
        <div class="col-6 col-lg-3">selectedEmailForVP$: {{!!(selectedEmailForViewingPane$ | async)}}</div>
        <div class="col-6 col-lg-3" *ngIf="paginationInfo$ | async as pi">Pagination p:{{pi.numPages}} t:{{pi.total}} i: {{pi.currentPageIndex}} {{pi.havePreviousPage}} | {{pi.haveNextPage}}</div>
        <div class="col-6 col-lg-3" *ngFor="let f of (fileAttachments$ | async)">{{f.name}}</div>
    </div> -->

    <ng-template #folderTempl>
        <div class="folder-list">
            <div *ngFor="let folder of folderList$ | async">
                <div (click)="onSelectFolder(folder)" class="folder alert pill row"
                    [ngClass]="{'selected': folder.isSelected}">
                    <div class="col">{{folder.code}}</div>
                    <div class="col unread-count" *ngIf="folder.code === 'Inbox' && folder.unreadEmailCount > 0">{{folder.unreadEmailCount}}
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #emailListTempl>
        <div *ngIf="emailList$ | async as emailList">
            <div class="email-list">

                <!-- header -->
                <div class="row email-list-header">
                    <div class="col-8 d-flex flex-column" *ngIf="selectedFolder$ | async as folder">
                        <span class="adminPageHeader" >{{folder.displayName}}</span>
                        <a  *ngIf="folder.displayName == 'Inbox'" style="overflow: visible;">{{agentEmailAddress}}</a>
                    </div>
                    <div class="col-4 email-list-header-toolbar align-self-start">
                        <a (click)="onRefresh()" title="Refresh"><fa-icon icon="refresh"></fa-icon></a>&nbsp;&nbsp;

                        <a [matMenuTriggerFor]="filterMenu" title="Filter Options"><fa-icon
                                icon="bars-filter"></fa-icon></a>
                        <mat-menu #filterMenu="matMenu" xPosition='before' class="popout-menu">
                            <div class="filter-menu">
                                <div>Filter by</div>
                                <button mat-menu-item (click)="setFilterByUnread(false)"><fa-icon
                                        [icon]="['far', ((isFilterByUnread$ | async) ? 'square': 'check-square')]"></fa-icon>&nbsp;No
                                    Filter</button>
                                <button mat-menu-item (click)="setFilterByUnread(true)"><fa-icon
                                        [icon]="['far', ((isFilterByUnread$ | async) ? 'check-square': 'square')]"></fa-icon>&nbsp;Unread</button>

                                <div class="Vert-15"></div>

                                <div>Sort by</div>
                                <button mat-menu-item (click)="setSortDescending(true)"><fa-icon
                                        [icon]="['far', ((isSortDescending$ | async) ? 'check-square':'square' )]"></fa-icon>&nbsp;Date
                                    - Newest on top</button>
                                <button mat-menu-item (click)="setSortDescending(false)"><fa-icon
                                        [icon]="['far', ((isSortDescending$ | async) ? 'square':'check-square' )]"></fa-icon>&nbsp;Date
                                    - Oldest on top</button>

                                <a (click)="onResetFilterAndSearch()">Reset</a>
                            </div>
                        </mat-menu>
                    </div>
                </div>

                <ng-container *ngIf="pageMode === 'SearchResults'">
                    <div class="search-results-header"
                        *ngIf="emailSearchSummary$ | async as searchSummary">
                        {{searchSummary.count}} result<span *ngIf="searchSummary.count !== 1">s</span> for "{{searchText}}"
                    </div>
                </ng-container>

                <lgv-loading-indicator *ngIf="isLoading$ | async" [CSSClass]="'Small'"></lgv-loading-indicator>

                <div class="row email-wrapper"
                    [ngClass]="{'make-room-for-scroll-bar': emailList.length > 8 }">
                    <div>
                        <div class="col-12 email-summary" (click)="onEmailClicked(email)"
                            [ngClass]="{'unread': !(!!email.isRead) && email.folder !== 'Draft', 'selected': email.isSelected}"
                            *ngFor="let email of emailList">
                            <div class="row sender-toolbar-parent align-items-center">
                                <div class="col-9 sender">
                                    <span *ngIf="email.folder !== 'Sent' && email.folder !== 'Draft'" [innerHTML]="emailContactDisplay([email.fromFull])"></span>
                                    <span *ngIf="email.folder === 'Sent' || email.folder === 'Draft'" [innerHTML]="emailContactDisplay(email.toFull)"></span>
                                </div>
                                <div class="col-3 toolbar gray-icon">
                                    <div class="hover-hide">
                                        <fa-icon *ngIf="!!email.attachments?.length > 0" class="gray-icon" icon="paperclip"></fa-icon>
                                        <fa-icon *ngIf="!(!!email.isRead) && email.folder === 'Inbox'" class="primary-color circle-icon" icon="circle"></fa-icon>
                                    </div>
                                    <div class="col-12 hover-show">
                                        <a (click)="onConfirmDeleteEmail(email); $event.stopPropagation();"><fa-icon
                                                icon="trash" title="Delete this email"></fa-icon></a>
                                        <a *ngIf="!(!!email.isRead) && email.folder === 'Inbox'"
                                            (click)="markEmailAsRead(email); $event.stopPropagation();"
                                            title="Mark as Read"><fa-icon
                                                icon="envelope-open"></fa-icon></a>
                                        <a *ngIf="!!email.isRead && email.folder === 'Inbox'"
                                            (click)="markEmailAsUnread(email); $event.stopPropagation();"
                                            title="Mark as Unread"><fa-icon
                                                icon="envelope"></fa-icon></a>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-9 subject"
                                    [ngClass]="{'primary-color': !(!!email.isRead)}">
                                    {{email.subject}}</div>
                                <div class="col-3 timestamp">{{email.receivedDateUtc | LgvDateOrTime}}
                                </div>
                            </div>
                            <div class="preview" [innerHTML]="email.textBody"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pagination-info folderView" *ngIf="paginationInfo$ | async as pi">
                {{pi.rangeText}}&nbsp;&nbsp;
                <button class="pagination-btn" (click)="onPreviousPage()"
                    [disabled]="!(pi.havePreviousPage)" title="Previous Page"><fa-icon
                        icon="chevron-left"></fa-icon></button>&nbsp;&nbsp;
                <button class="pagination-btn" (click)="onNextPage()" [disabled]="!(pi.haveNextPage)"
                    title="Next Page"><fa-icon icon="chevron-right"></fa-icon></button>
            </div>
        </div>
    </ng-template>

    <ng-template #emailDetailTempl>
        <!-- View Email Details -->
        <div class="email-detail-view" *ngIf="pageMode !== 'ComposeEmail'">
            <div *ngIf="selectedEmailForViewingPane$ | async as email; else noEmailSelected">
                <div class="row">
                    <div class="col-8">
                        <div class="subject float-start">{{email.subject}}</div>
                        <div class="tagged-clients" *ngIf="email.clients?.length > 0">
                            <div class="alert pill tagged-client" *ngFor="let client of email.clients">
                                <a (click)="onOpenClientInNewWindow(client.id)" title="View Client Details"><fa-icon icon="user-circle"></fa-icon> {{client.firstName}} {{client.lastName}}</a>&nbsp;&nbsp;
                                <a (click)="untagThisClient(client, email)" title="Untag client"><fa-icon icon="close"></fa-icon></a>
                            </div>
                            <div style="clear:both"></div>
                        </div>
                        <div style="clear:both"></div>

                    </div>
                    <!-- Toolbar -->
                    <div class="col-4 email-action-toolbar">
                        <ng-container *ngIf="!(isMobile$ | async)">
                            <a (click)="onReply(email)" title="Reply"><fa-icon icon="reply"></fa-icon></a>&nbsp;&nbsp;
                            <a (click)="onReplyAll(email)" title="Reply All"><fa-icon
                                    icon="reply-all"></fa-icon></a>&nbsp;&nbsp;
                            <a (click)="onForward(email)" title="Forward"><fa-icon
                                    icon="share"></fa-icon></a>&nbsp;&nbsp;
                                    <a (click)="onToggleFullScreenEmailView(email)" title="Full Screen"><fa-icon
                                        [icon]="isFullScreenEmailView$.value ? 'compress-alt': 'expand-alt'"></fa-icon></a>&nbsp;&nbsp;
                        </ng-container>

                        <a [matMenuTriggerFor]="menu" title="More Options"><fa-icon
                                icon="bars"></fa-icon></a>

                        <mat-menu #menu="matMenu" xPosition='before' class="popout-menu">

                            <ng-container *ngIf="isMobile$ | async">
                                <button mat-menu-item (click)="onReply(email)"><fa-icon
                                        icon="reply"></fa-icon>Reply</button>
                                <button mat-menu-item (click)="onReplyAll(email)"><fa-icon
                                        icon="reply-all"></fa-icon>Reply All</button>
                                <button mat-menu-item (click)="onForward(email)"><fa-icon
                                        icon="share"></fa-icon>Forward</button>
                            </ng-container>


                            <button mat-menu-item *ngIf="!email.isRead && email.folder === 'Inbox'"
                                (click)="markEmailAsRead(email)"><fa-icon icon="envelope-open"></fa-icon>Mark as
                                Read</button>
                            <button mat-menu-item *ngIf="email.isRead && email.folder === 'Inbox'"
                                (click)="markEmailAsUnread(email)"><fa-icon icon="envelope"></fa-icon>Mark as
                                Unread</button>
                            <button mat-menu-item (click)="onConfirmDeleteEmail(email)"><fa-icon icon="trash"></fa-icon>Delete</button>
                            <button mat-menu-item *ngIf="email.folder !== 'Junk'"
                                (click)="markEmailAsSpam(email, true)"><fa-icon
                                    icon="triangle-exclamation"></fa-icon>Mark as Spam</button>
                            <button mat-menu-item *ngIf="email.folder === 'Junk' || email.folder === 'Deleted'"
                                (click)="moveEmailToInbox(email, false)"><fa-icon icon="triangle-exclamation"></fa-icon>Move to Inbox</button>
                            <button mat-menu-item (click)="linkEmailToClient(email)"><fa-icon
                                    icon="user-check"></fa-icon>Link to Client</button>
                        </mat-menu>
                    </div>
                </div>
                <div class="Vert-10"></div>

                <div class="row">
                    <div class="col-8"><span class="sender-name">{{email.fromFull?.name}}</span> <span
                            class="sender-email">
                            <{{email.fromFull?.email}}>
                        </span></div>
                    <div class="col-4 timestamp">{{email.receivedDateUtc | date:'EEEE, MMMM dd'}},
                        {{email.receivedDateUtc | date:'shortTime'}}</div>
                </div>

                <div class="recipient">to
                    <ng-container *ngFor="let emailContact of email.toFull; let isLast = last">
                        <span>{{emailContact?.name?.length > 0 ? emailContact.name :
                            emailContact.email}}</span><span *ngIf="!isLast">, </span>
                    </ng-container>
                </div>

                <!-- Attachments -->
                <div class="row" *ngIf="email.attachments?.length > 0" class="attachments-container">
                    <div *ngFor="let attachment of email.attachments" class="float-start attachment"
                        (click)="onOpenAttachment(email, attachment)">
                        <fa-icon class="gray-icon" icon="paperclip"></fa-icon>{{attachment.name}}
                    </div>
                </div>

                <hr />

                <ng-container *ngIf="{emailBody: (safeEmailBody$ | async)} as emailBodyWrapper">
                    <div class="email-body" *ngIf="emailBodyWrapper.emailBody">
                        <div [innerHTML]="emailBodyWrapper.emailBody"></div>
                    </div>

                    <div *ngIf="!emailBodyWrapper.emailBody">
                        <div class="Vert-20"></div>
                        <lgv-loading-indicator [CSSClass]="'Small'"></lgv-loading-indicator>
                    </div>

                    <div *ngIf="emailWasTruncated$ | async" class="show-original-link">
                        <a (click)="showOriginalEmail()" class="text-primary cursor-pointer" style="text-decoration: none;">
                            <small>
                                <fa-icon [icon]="['fas', 'expand']"></fa-icon>
                                Show Entire Email (in new window)
                            </small>
                        </a>
                    </div>
                    
                    <div class="email-view-footer">
                        <button class="btn white" (click)="onReply(email)"><fa-icon icon="reply"
                                [disabled]="!emailBodyWrapper.emailBody"></fa-icon>Reply</button>
                        <button class="btn white" (click)="onForward(email)"><fa-icon icon="share"
                                [disabled]="!emailBodyWrapper.emailBody"></fa-icon>Forward</button>
                    </div>
                </ng-container>

            </div>

            <ng-template #noEmailSelected>
                <div class="nothing-selected">
                    <p>Select an item to read</p>
                    <p><fa-icon icon="envelope-open"></fa-icon></p>
                    <p>Nothing is selected</p>
                </div>
            </ng-template>

        </div>

        <!-- Compose Email -->
        <div class="background-card full-height compose-email-view" *ngIf="pageMode === 'ComposeEmail'">
            <div class="row">
                <div class="col-6">
                    <button class="btn btn-primary" (click)="onSendEmail()"
                        [disabled]="!isReadyToSend">Send</button>
                </div>
                <div class="col-6 toolbar">
                    <ng-container>
                        <a (click)="onConfirmDiscardDraft();"><fa-icon icon="trash"
                            title="Delete this draft email"></fa-icon></a>
                        <a (click)="onSaveDraft(email)">
                            <fa-icon icon="floppy-disk"
                            title="Save draft "></fa-icon>
                        </a>
                    </ng-container>
                    <div class="save-timestamp" *ngIf="lastSaveTime$ | async as lastSave">
                        Draft auto-saved at {{lastSave | date:'shortTime'}}
                    </div>
                </div>
            </div>

            <div class="Vert-20"></div>
            <lgv-loading-indicator *ngIf="(isSending$ | async) || (isSaving$ | async)"
                [CSSClass]="'Small Floating'"></lgv-loading-indicator>

            <div class="row align-items-center mb-2">
                <div class="col-2">
                    To:
                </div>
                <div class="col-9">
                    <!-- <input type="text" class="email-field" [(ngModel)]="rawEmailToString" /> -->
                     <lgv-email-input [defaultContactList]="defaultToEmailList$ | async" (onEmailListUpdated)="onToListUpdated($event); onEmailContentChanged()"></lgv-email-input>
                </div>
                <div class="col-1" style="text-align: center;">
                    <a (click)="onToggleCC()">CC</a>
                </div>
            </div>
            <div class="row align-items-center mb-2" *ngIf="showCC$ | async">
                <div class="col-2">
                    CC:
                </div>
                <div class="col-10">
                    <!-- <input type="text" class="email-field" [(ngModel)]="rawEmailCCString" /> -->
                    <lgv-email-input [defaultContactList]="defaultCCEmailList$ | async" (onEmailListUpdated)="onCCListUpdated($event); onEmailContentChanged()"></lgv-email-input>
                </div>
            </div>

            <div class="row align-items-center mb-2">
                <div class="col-2">
                    Subject:
                </div>
                <div class="col-10">
                    <input type="text" class="email-field" [(ngModel)]="emailDraft.subject" (ngModelChange)="onEmailContentChanged()" />
                </div>
            </div>

            <div class="row">
                <div class="col-12">

                    <!-- Local File Attachments from Device -->
                    <ng-container *ngIf="(fileAttachments$ | async) as attachments">
                        <div class="alert pill attached-file" *ngFor="let a of attachments">
                            <fa-icon icon="paperclip"></fa-icon> {{a.file.name}}
                            <a (click)="removeThisAttachment(a)"><fa-icon icon="close"></fa-icon></a>
                        </div>
                    </ng-container>

                    <!-- Saved Email Attachments -->
                    <ng-container *ngIf="savedAttachments$ | async as savedAttachments">
                        <div *ngFor="let sa of savedAttachments" class="alert pill attached-file">
                            <fa-icon icon="paperclip"></fa-icon>{{sa.name}} <a
                                (click)="removeSavedAttachmentFromDraft(sa)"><fa-icon
                                    icon="close"></fa-icon></a>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="Vert-15"></div>

            <!-- Quill Editor with Custom Toolbar -->
            <quill-editor class="editor" [(ngModel)]="emailDraft.htmlBody" (ngModelChange)="onEmailContentChanged()"
                [placeholder]="'Email Message Body'">
                <div quill-editor-toolbar>
                    <span class="ql-formats">
                        <button class="ql-bold" title="Bold"></button>
                        <button class="ql-italic" title="Italic"></button>
                        <button class="ql-underline" title="Underline"></button>
                        <button class="ql-strike" title="Strike"></button>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-blockquote" title="Block Quote"></button>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-list" value="ordered" title="Ordered List"></button>
                        <button class="ql-list" value="bullet" title="Bullet List"></button>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-script" value="sub"></button>
                        <button class="ql-script" value="super"></button>
                    </span>
                    <span class="ql-formats">
                        <select class="ql-align" [title]="'Aligment'">
                            <option selected></option>
                            <option value="center"></option>
                            <option value="right"></option>
                            <option value="justify"></option>
                        </select>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-clean"></button>
                    </span>
            
                    <span class="ql-formats">
                        <button class="ql-link"></button>
                    </span>
            
                    <span class="ql-formats">
                        <button class="custom-button" (click)="fileInput.click()"><fa-icon icon="paperclip"></fa-icon></button>
                        <input hidden="true" class="btn btn-secondary" type="file" #fileInput
                            (change)="fileChangeEvent($event); onEmailContentChanged()"
                            accept="image/*, .doc, application/pdf, .DOC, .DOCM, .DOCX, .DOT, .DOTM, .DOTX, .RTF, .TXT, .ODT, .OTT, .XLSX, .XLSB, .XLS2003, .XLT, .XLTX, .XLTM, .XLAM, .ODS, .TSV, .CSV, .XLS, .XLSM, .PDF, .XPS, .MSG, .EML, .EMLX"
                            required>
                    </span>
                </div>
            </quill-editor>

            <div *ngIf="emailWasTruncated$ | async" class="show-original-link">
                <a (click)="showOriginalEmail()" class="text-primary cursor-pointer" style="text-decoration: none;">
                    <small>
                        <fa-icon [icon]="['fas', 'expand']"></fa-icon>
                        Show Entire Email (in new window)
                    </small>
                </a>
            </div>

            <div class="Vert-30"></div>
            <div class="row">
                <div class="col-12">
                    <span><b>Signature</b></span>
                    <div class="Vert-30"></div>
                    <span>
                        <div #agentSignatureElement>
                            <lgv-agent-signature></lgv-agent-signature>
                        </div>
                        <small><i>Note, this infomation comes from your <a (click)="onClickAgentProfileLink()">Realfinity Platform
                                    profile</a>.</i>
                        </small>
                    </span>
                </div>
            </div>

        </div>

    </ng-template>

    <!--Side Nav-->
    <mat-sidenav #slideMenu mode="over">
        <div class="slide-menu">
            <div style="text-align: right;">
                <a (click)="slideMenu.close()" title="Close"><fa-icon icon="close"></fa-icon></a>
            </div>
            <div class="Vert-10"></div>

            <ng-template [ngTemplateOutlet]="folderTempl"></ng-template>
        </div>
    </mat-sidenav>


    <ng-container *ngIf="LgvUserSvc?.DBUserSS$ | async as dbUserSS">

        <!-- Selected Clients Row -->
        <div class="selected-clients" *ngIf="selectedClients$ | async as selectedClients">
            <div class="alert pill selected-client" *ngFor="let client of selectedClients">
                <a (click)="onOpenClientInNewWindow(client.id)" title="Go to Client"><fa-icon icon="user-circle"></fa-icon> {{client.firstName}} {{client.lastName}}</a>&nbsp;&nbsp;
                <a (click)="onUnselectClient(client)" title="Unselect client"><fa-icon icon="close"></fa-icon></a>
            </div>
            <div style="clear:both"></div>
        </div>

        <!-- Standard Header Row -->
        <ng-container *ngIf="pageMode !== 'ViewEmailMobile'">
            <div class="row header-row">
                <div class="col-lg-2 col-4">
                    <div class="bars-icon">
                        <a class="d-block d-md-none" (click)="slideMenu.open()" title="Menu"><fa-icon icon="bars"></fa-icon></a>
                        <a class="d-none d-lg-block" (click)="onToggleFolderPane()" title="Menu"><fa-icon icon="bars"></fa-icon></a>
                    </div>
                    <button class="float-start btn btn-primary new-mail skinny" (click)="onNewMail()"
                        [disable]="pageMode !== 'Default'" *ngIf="pageMode !== 'ComposeEmail'">New<span *ngIf="!(isMobile$ | async)"> Mail</span></button>
                </div>


                <!-- Full Screen - Return to Folder -->
                <div class="col-lg-10 col-8" *ngIf="isFullScreenEmailView$ | async">
                    <div class="float-start" style="margin-top:10px;" *ngIf="selectedFolder$ | async as folder">
                        <a (click)="onExitFullScreen()"><fa-icon icon="arrow-left"></fa-icon>&nbsp;&nbsp;Return to {{folder.displayName}}</a></div>
                </div>

                <!-- Search -->
                <div class="col-lg-10 col-8" *ngIf="!(isFullScreenEmailView$ | async)">
                    <div #searchDivParent class="search-area-parent">
                        <div #searchDiv class="alert lgv-border search-area"
                            [ngClass]="{'expanded': (searchIsExpanded$ | async) }"
                            (click)="onSearchAreaClicked($event)">
                            <div class="row search-row">
                                <div class="search-icon"><fa-icon icon="search"></fa-icon></div>
                                <div class="search-box col"><input type="text" [placeholder]="'Search'"
                                        [(ngModel)]="searchText" (ngModelChange)="onSearchTextChange()" /></div>
                                <div class="search-icon" style="margin-right:15px"><a
                                        (click)="onClearSearch(); $event.stopPropagation();"
                                        *ngIf="searchText.length > 0"><fa-icon icon="close"></fa-icon></a></div>
                            </div>
                            <div class="search-results" *ngIf="searchIsExpanded$ | async">
                                <hr />
                                <lgv-loading-indicator *ngIf="isSearchingClients$ | async"
                                    [CSSClass]="'Floating UltraCompact'"></lgv-loading-indicator>
                                <div>Clients:</div>
                                <ng-container *ngIf="clientSearchSummary$ | async">
                                    <ng-container *ngIf="clientSearchResultsShortList$ | async as clientResults">
                                        <div class="result clickable hover-bgColor" *ngFor="let client of clientResults"
                                            (click)="onClientSearchResultClicked(client)">
                                            <fa-icon icon="user-circle"></fa-icon>&nbsp;{{client.firstName}}
                                            {{client.lastName}}
                                            | {{client.email}}
                                        </div>
                                        <div *ngIf="clientResults.length === 0">
                                            <div class='small'>No Results...</div>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <hr />
                                <lgv-loading-indicator *ngIf="isSearchingEmails$ | async"
                                    [CSSClass]="'Floating UltraCompact'"></lgv-loading-indicator>
                                <div>Emails:</div>
                                <ng-container *ngIf="emailSearchSummary$ | async">
                                    <ng-container *ngIf="emailSearchResultsShortList$ | async as emailSearchResults">

                                        <div class="result clickable hover-bgColor"
                                            *ngFor="let email of emailSearchResults"
                                            (click)="onEmailSearchResultClicked(email)">
                                            <div class="result-icon">
                                                <fa-icon icon="envelope"></fa-icon>
                                            </div>
                                            <div class="result-main">
                                                <div class="line1">
                                                    {{email.subject}}
                                                </div>
                                                <div class="line2">
                                                    {{emailContactsToString(email.toFull)}}
                                                </div>
                                            </div>
                                            <div style="clear:both"></div>
                                        </div>

                                        <div *ngIf="emailSearchResults.length === 0">
                                            <div class='small'>No Results...</div>
                                        </div>
                                        <ng-container *ngIf="emailSearchSummary$.value.count > 5">
                                            <hr />
                                            <div class="clickable" (click)="onShowAllResultsForSearch()"><fa-icon
                                                    icon="search"></fa-icon>&nbsp;&nbsp;Show all results with
                                                "{{searchText}}"
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="Vert-15" *ngIf="isFullScreenEmailView$ | async"></div>
            </div>

        </ng-container>

        <!-- Mobile Email View Header Row -->
        <ng-container *ngIf="pageMode === 'ViewEmailMobile'">
            <div class="row header-row">
                <div class="d-flex justify-content-between align-items-center w-100">
                    <div class="bars-icon">
                        <a class="d-block d-md-none" (click)="slideMenu.open()"><fa-icon icon="bars"></fa-icon></a>
                    </div>

                    <div class="background-card skinny" *ngIf="selectedEmailForViewingPane$ | async as email">
                        <div class="pagination-info mobileView"
                            *ngIf="{pi: paginationInfo$ | async, selectionIndex: currentSelectionIndex(email) +1 } as paginationWrapper">
                            <span class="page-count">{{paginationWrapper.selectionIndex}} of {{paginationWrapper.pi.total}}</span>
                            <div class="pagination-controls">
                                <button class="pagination-btn" (click)="onPreviousOrNextEmail(true)"
                                    [disabled]="(paginationWrapper.selectionIndex === 1)" title="Previous Email">
                                    <fa-icon icon="chevron-left"></fa-icon>
                                </button>
                                <button class="pagination-btn" (click)="onPreviousOrNextEmail(false)"
                                    [disabled]="(paginationWrapper.selectionIndex === paginationWrapper.pi.total)"
                                    title="Next Email">
                                    <fa-icon icon="chevron-right"></fa-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>



        <!-- ============================ Desktop View ============================ -->
        <div class="d-none d-md-flex" [ngClass]="(showingFolderPaneInDesktopMode$ | async) ? '' : 'right-margin-hack-for-splitter'">

            <!-- Desktop - Regular -->
            <ng-container *ngIf="!(isFullScreenEmailView$ | async)" class="row">

                <!-- Folder View -->
                <div class="folder-list col-lg-2 col-md-4" *ngIf="(showingFolderPaneInDesktopMode$ | async)">
                    <ng-template [ngTemplateOutlet]="folderTempl"></ng-template>
                </div>

                <div class="row splitter-wrapper col-lg-10 col-md-8">

                    <as-split direction="horizontal" gutterSize="15" class="splitter">

                        <as-split-area [size]="30" minSize="20">

                            <!-- email list / folder contents -->
                            <div class="email-list-pane main-column mat-card" *ngIf="pageMode !== 'ViewEmailMobile' && !(isFullScreenEmailView$ | async) && !((isMobile$ | async) && pageMode === 'ComposeEmail')">
                                <ng-template [ngTemplateOutlet]="emailListTempl"></ng-template>
                            </div>
                            
                        </as-split-area>

                        <!-- Email View (right side) -->
                        <as-split-area [size]="70" minSize="50">
                            <div class="right-pane main-column mat-card">
                                <ng-template [ngTemplateOutlet]="emailDetailTempl"></ng-template>
                            </div>
                        </as-split-area>
                    </as-split>
                </div>
            </ng-container>
            
            <!-- Desktop - *Full Screen* -->
            <ng-container *ngIf="(isFullScreenEmailView$ | async)">
                <div class="d-none d-md-block w-100">
                    <div class="right-pane main-column mat-card">
                        <ng-template [ngTemplateOutlet]="emailDetailTempl"></ng-template>
                    </div>
                </div>
            </ng-container>

        </div>


        <!-- ============================ Mobile View ============================ -->
        <div class="d-block d-md-none">
            <!-- Folder View -->
            <div class="folder-list"
                *ngIf="(showFolderPane$ | async) && !(isFullScreenEmailView$ | async) && !(isMobile$ | async)">
                <ng-template [ngTemplateOutlet]="folderTempl"></ng-template>
            </div>

            <!-- Mobile Email list -->
            <div class="email-list-pane mat-card" 
            *ngIf="pageMode !== 'ViewEmailMobile' && !(isFullScreenEmailView$ | async) && !((isMobile$ | async) && pageMode === 'ComposeEmail')">
                <ng-template [ngTemplateOutlet]="emailListTempl"></ng-template>
            </div>
        
            <!-- Mobile Email View -->
            <div class="right-pane main-column mat-card" *ngIf="!(isMobile$ | async) || pageMode === 'ViewEmailMobile' || pageMode === 'ComposeEmail'">
                <ng-template [ngTemplateOutlet]="emailDetailTempl"></ng-template>
            </div>


        </div>




        <div class="Vert-20"></div>

    </ng-container>

</div>